import React, { useEffect } from 'react';
import { Layout, Row, Card, Input, Button, Form, theme, message } from 'antd';
import { AppIcon } from '../../../assets/icons';
import {
  headStyles,
  cardTitle,
  resetPasswordTitle,
  bodyStyles,
  containerStyles,
  resetSubPasswordTitle,
} from './styles';
import { useTranslation } from '@refinedev/core';
import { LanguageSwitcher } from '@/components/layout/changeLang';
import useAPI from '@/api/useApi';
import { endPoints } from '@/api/configs';
import { useNavigation } from '@refinedev/core';
import { setAuthToken } from '@/rest-data-provider/utils/axios';
import { motion } from 'framer-motion';
import { useProfileStore } from '@/core';
import { removeItem } from '@/core/storage';

export const Verification: React.FC = () => {
  const { forgotPasswordEmail } = useProfileStore();
  const { token } = theme.useToken();
  const { usePost } = useAPI();
  const { push } = useNavigation();
  const { isLoading, mutateAsync: verifyEmail } = usePost<
    string,
    { email: string; otp: string }
  >(endPoints.verifyEmail);
  const { translate } = useTranslation();
  const onSubmit = (values: { code: string }) => {
    verifyEmail(
      { email: forgotPasswordEmail || '', otp: values.code },
      {
        onSuccess: (data) => {
          const res = data.data.data;
          setAuthToken(res);
          push('/reset-password');
          removeItem('forgotPasswordEmail');
        },
        onError: (error) => {
          message.error(error.message);
        },
      }
    );
  };
  const CardTitle = (
    <div style={cardTitle}>
      <AppIcon />
      <div style={{ ...resetPasswordTitle }}>
        {translate('pages.verification.title')}
      </div>
      <div style={{ ...resetSubPasswordTitle }}>
        {forgotPasswordEmail
          ? translate('pages.verification.subTitle', {
              forgotPasswordEmail,
            })
          : translate('pages.verification.subTitle2')}
      </div>
    </div>
  );
  useEffect(() => {
    if (!forgotPasswordEmail) {
      push('/forgot-password');
    }
  }, [forgotPasswordEmail, push]);
  return (
    <Layout>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          position: 'absolute',
          top: '24px',
          right: '24px',
          zIndex: 999,
        }}
      >
        <LanguageSwitcher />
      </motion.div>

      <Row
        justify="center"
        align="middle"
        style={{
          padding: '16px 0',
          minHeight: '100dvh',
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Card
            title={CardTitle}
            styles={{ header: headStyles, body: bodyStyles }}
            style={{
              ...containerStyles,
              backgroundColor: token.colorBgElevated,
            }}
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              <Form layout="vertical" onFinish={onSubmit}>
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.5, duration: 0.5 }}
                >
                  <Form.Item
                    name="code"
                    rules={[
                      {
                        required: true,
                        message: translate('pages.verification.codeError'),
                      },
                      {
                        pattern: /^[0-9]*$/,
                        message: translate('pages.verification.codeError'),
                      },
                    ]}
                    style={{ width: '80%', margin: 'auto' }}
                  >
                    <Input.OTP
                      size="large"
                      length={4}
                      style={{ width: '100%', direction: 'ltr' }}
                    />
                  </Form.Item>
                </motion.div>

                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.7, duration: 0.5 }}
                >
                  <Button
                    type="primary"
                    className="mt-8"
                    size="large"
                    htmlType="submit"
                    block
                    style={{
                      backgroundColor: token.colorPrimary,
                    }}
                    loading={isLoading}
                  >
                    {translate('pages.verification.verify')}
                  </Button>
                </motion.div>
              </Form>
            </motion.div>
          </Card>
        </motion.div>
      </Row>
    </Layout>
  );
};
